/**
 * 妙问机器人
 */
import cookie from '@/utils/cookie';
import { AGENCY_UID_COOKIE_NAME } from '@/constants/Constants';
import globalStore from '@/stores';

export default  {
  init: () => {
    if (!window.smartQ) {
      return;
    }
    const { account } = globalStore;
    const source = 5; // 5-服务商系统-已登录
    const userId = account.user_id;
    const uid = cookie.get(AGENCY_UID_COOKIE_NAME.default) || account.bm_id || account.agency_uid;
    const uriPath = location.href.split('?')[0];
    const code = btoa(`${new Date().getTime()}_${source}_${cookie.get('gdt_protect') || 0}_${userId}_${uid}_${btoa(uriPath)}`);
    window.smartQ.init({
      comefrom: 'agency',
      code,
    });
  },
};
